/* eslint-disable no-use-before-define */
/* eslint-disable no-loop-func */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { QuotationDataForSite } from '../../util/WebcadJSONExporter';
/**
 * 保存ダイアログ
 */
class SavePlanDialog extends Dialog {
    hasPlanID:boolean = false;

    saveAs:boolean = false;

    title:string;

    /**
     * コンストラクタ
     */
    constructor(draggable) {
      super(draggable);

      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.planID !== undefined
        && marietta.webcad.WebCADGlobal.webcad2Dmanager.planID !== null
        && marietta.webcad.WebCADGlobal.webcad2Dmanager.planID !== '') {
        this.hasPlanID = true;
      }

      // ダイアログのコンテンツ生成
      const id = 'saveDialog';
      let title = '';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = !this.hasPlanID ? 'Save' : 'Save(Update)'; break;
        default: title = !this.hasPlanID ? '新規保存' : '保存（更新）'; break;
      }

      let contents = '<div class="dialogSaveDialog">\n';
      contents += '<div class="tableBox">\n';
      contents += `<p class="notationMessage">
                    <span class="jp">現在編集中のデータを保存します。</span><span class="en">Would you like to save your changes?</span><br>
                    <span class="warn fz12"><span class="jp">※下絵は保存されません。</span><span class="en">*Any draft pictures will not be saved.</span></span><br>
                    <span class="warn fz12"><span class="jp">※付帯工事情報が設定されていない</span><span class="en">*Data for pins for which no ancillary</span></span><br>
                    <span class="warn fz12"><span class="jp">ピンのデータは保存されません。</span><span class="en"> construction information has been set will not be saved.</span></span>
                  </p>\n`;

      contents += '<table>\n';
      contents += '<tbody>\n';
      // 別名保存
      if (this.hasPlanID) {
        contents += '<tr>\n<th>\n';
        contents += '<label class="itemMenuCheckbox">';
        contents += '<input id="saveAsCheckBox" type="checkbox">';
        contents += '<span class="labelName"><span class="jp">別名で新規登録をする</span><span class="en">Save As</span></span>';
        contents += '</label>';
        contents += '</th>\n</tr>\n';
      }
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '<p class="dialogInlineError" id="dialogSaveDialogError"></p>\n';
      contents += '</div>\n';
      contents += '</div>\n';
      let footer = '<button id="btnDoneSave"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="dialogSaveDialog_btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);

      // イベント設定
      let btn = document.querySelector('#btnDoneSave');
      btn.addEventListener('click', this.onOKClicked);

      btn = document.querySelector('#dialogSaveDialog_btnCancel');
      btn.addEventListener('click', this.onCancelClicked);

      if (this.hasPlanID) {
        btn = document.querySelector('#saveAsCheckBox');
        btn.addEventListener('click', this.saveAsCheckBoxClicked);
        if (this.saveAs) {
          (<HTMLInputElement>document.getElementById('saveAsCheckBox')).checked = true;
        }
      }
    }

    /**
     * 別名保存モード
     */
    showAsSaveAs() {
      // 別名保存のチェックボックスを選択状態にする
      this.saveAs = true;

      try {
        (<HTMLInputElement>document.getElementById('saveAsCheckBox')).checked = true;
      } catch (error) {
        //
      }
    }

    /**
    * 別名保存ボタンがクリックされた
    */
    saveAsCheckBoxClicked = () => {
      this.saveAs = (<HTMLInputElement>document.getElementById('saveAsCheckBox')).checked;
    }

    /**
    * Cancelボタンがクリックされた
    */
    onCancelClicked = () => {
      // webcadを閉じるフラグをおろす
      marietta.webcad.WebCADGlobal.webcad2Dmanager.closeWebcadAfterEvent = false;

      this.close();
      //            var evt = document.createEvent("MouseEvents");
      //            evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      //            //タイトルバーの×ボタン
      //            $(this.viewObj).find('.dialogCloseBtn')[0].dispatchEvent( evt );
      //
      //            evt.initMouseEvent("touchend", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      //            $(this.viewObj).find('.dialogCloseBtn')[0].dispatchEvent( evt );
    }

    /**
    * OKボタンがクリックされた
    */
    onOKClicked = () => {
      marietta.webcad.WebCADGlobal.showBusy();

      // エラーメッセージの初期化
      document.getElementById('dialogSaveDialogError').innerText = '';

      // アイテムの有無の確認
      const itemList = marietta.webcad.WebCADGlobal.layerGroup.getAllItems();

      if (itemList.length > 0) {

        //見積データの再構築
        marietta.webcad.WebCADGlobal.quotationItemList.createData(false, false);

        // //見積データの入力チェック
        // const { tableDataQuotation } = marietta.webcad.WebCADGlobal.quotationItemList;
        // for (let i: number = 0; i < tableDataQuotation.length; i += 1) {
        //   if (!tableDataQuotation[i].is_quote) continue;
        //   if( -1 < tableDataQuotation[i].name.indexOf('巾木') ) continue;
        //   if( !tableDataQuotation[i].end_item_info || !this.inputCheck(tableDataQuotation[i]) ){
        //     marietta.webcad.WebCADGlobal.showAlert( '見積データが完全でありません。入力を確認してください。' );
        //     marietta.webcad.WebCADGlobal.hideBusy();
        //     return;
        //   }
        // }
        //20241002 データの送信制限解除

        // DBからピン情報削除→ピンの画像登録→保存処理
        marietta.webcad.WebCADGlobal.webcad2Dmanager
          .deletePin()
          .then(() => marietta.webcad.WebCADGlobal.webcad2Dmanager.savePin().then(() => this.sendSaveData()))
          .catch((err) => {
            console.log(err);
            marietta.webcad.WebCADGlobal.hideBusy();
            this.close();
            if (typeof err === 'string' && err.includes("Pin")) {
              // ピンの登録失敗
              marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_PIN_REGISTER'));
            }
          });
      } else {
        marietta.webcad.WebCADGlobal.hideBusy();
        this.close();

        // アラート
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_SAVE_NOPLAN'));
      }
    }

    /**
     * 見積の入力チェック
     */
    private inputCheck( data:any ):boolean{
      if( !data.hasOwnProperty('unit') || !data.unit ) return false;
      if( !data.hasOwnProperty('maker') || !data.maker ) return false;
      if( !data.hasOwnProperty('part_number') || !data.part_number ) return false;
      if( !data.hasOwnProperty('item_name') || !data.item_name ) return false;
      if( !data.hasOwnProperty('item_sub_category') || !data.item_sub_category ) return false;
      if( !data.hasOwnProperty('price') || !data.price ) return false;

      return true;
    }


  /**
    * OKボタンがクリックされた
    */
    sendSaveData = () => {
      // エラーメッセージの初期化
      let floor1Image: string = '';
      let floor2Image: string = '';
      let floor3Image: string = '';
      let floor1ImageBinary: any = '';
      let floor2ImageBinary: any = '';
      let floor3ImageBinary: any = '';
      const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
      const p1 = new Promise((resolve: Function) => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.getFloorImage(1, 3600, 3600, 0/* png */, true, resolve);
      });
      p1.then((floor1Data: any) => {
        if (floor1Data.image_binary_base64 && floor1Data.status) {
          if (floor1Data.status === 'SUCCESS') {
            if (floor1Data.image_binary_base64) {
              floor1Image = floor1Data.image_binary_base64;
              floor1ImageBinary = marietta.webcad.util.WebCADUtil.dataURItoBlob('data:image/png;base64,' + floor1Image);
            }
          }
        }
        if (highestFloor > 1) {
          const p2 = new Promise((resolve: Function) => {
            marietta.webcad.WebCADGlobal.webcad2Dmanager.getFloorImage(2, 3600, 3600, 0/* png */, true, resolve);
          });
          p2.then((floor2Data: any) => {
            if (floor2Data.image_binary_base64 && floor2Data.status) {
              if (floor2Data.status === 'SUCCESS') {
                if (floor2Data.image_binary_base64) {
                  floor2Image = floor2Data.image_binary_base64;
                  floor2ImageBinary = marietta.webcad.util.WebCADUtil.dataURItoBlob('data:image/png;base64,' + floor2Image);
                }
              }
            }
            if (highestFloor > 2) {
              const p3 = new Promise((resolve: Function) => {
                marietta.webcad.WebCADGlobal.webcad2Dmanager.getFloorImage(3, 3600, 3600, 0/* png */, true, resolve);
              });
              p3.then((floor3Data: any) => {
                if (floor3Data.image_binary_base64 && floor3Data.status) {
                  if (floor3Data.status === 'SUCCESS') {
                    if (floor3Data.image_binary_base64) {
                      floor3Image = floor3Data.image_binary_base64;
                      floor3ImageBinary = marietta.webcad.util.WebCADUtil.dataURItoBlob('data:image/png;base64,' + floor3Image);
                    }
                  }
                }
                sentData();
              }).catch((msg: any) => {
                sentData();
              });
            } else {
              sentData();
            }
          }).catch((msg: any) => {
            sentData();
          });
        } else {
          sentData();
        }
      }).catch((msg: any) => {
        sentData();
      });

      const sentData = () => {
        document.getElementById('dialogSaveDialogError').innerText = '';

        // プラン名の保存
        const url = marietta.webcad.net.default.param.default.ActionName.UPDATE;

        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.planID === undefined) {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.planID = '';
        }

        // 見積リストの所属部屋名を更新する
        marietta.webcad.WebCADGlobal.quotationItemList.updateRoomTextForAllTables();

        // 別名保存の時、テンプレートモード時は、プランIDを送らない
        const formData = new FormData();
        // JSONを文字列に変換
        const jsondata = marietta.webcad.WebCADGlobal.webcad2Dmanager.getJSONSaveData();
        const quotedata = marietta.webcad.WebCADGlobal.webcad2Dmanager.getJSONQuoteDataForSite();
        const datetime = new Date();
        const date = new Date().toISOString().slice(0, 10).split('-')
          .map((d) => parseInt(d, 10))
          .join('');
        const floor1Filename = `floor1_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}.png`;
        const floor2Filename = `floor2_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}.png`;
        const floor3Filename = `floor3_${date}${datetime.getHours()}${datetime.getMinutes()}${datetime.getSeconds()}.png`;
        formData.append('webcad_data', jsondata);
        formData.append('1f_image', floor1ImageBinary ? new File([floor1ImageBinary], floor1Filename, { type: 'image/png' }) : '');
        formData.append('2f_image', floor2ImageBinary ? new File([floor2ImageBinary], floor2Filename, { type: 'image/png' }) : '');
        formData.append('3f_image', floor3ImageBinary ? new File([floor3ImageBinary], floor3Filename, { type: 'image/png' }) : '');
        formData.append('quote', quotedata);
        // formData.append('quote', '');
        formData.append('operation_type', marietta.webcad.WebCADGlobal.webcad2Dmanager.operation_type.toString());

        console.log( quotedata )

        const token = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.access_token}`;

        const self = this;
        const closeFunc = self.close;
        const headers = {
          Authorization: token,
          Accept: 'application/json',
        };
        fetch(url, {
          method: 'POST',
          body: formData,
          headers,
        }).then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.json();
          }
          throw Error(response.statusText);
        }).then((info) => {
          // ログイン済み
          if (info.error === undefined) {
            // ダイアログを閉じる
            closeFunc();

            // HideBusy
            marietta.webcad.WebCADGlobal.hideBusy();

            // 保存しましたダイアログを表示する
            marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('NOTICE_SAVED'));

            // 変更フラグの解除
            marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = false;

            if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '0') {
              marietta.webcad.WebCADGlobal.webcad2Dmanager.mode = '1';
            }

            // webcadを閉じるフラグが有効の場合は遷移する
            const { webcad2Dmanager } = marietta.webcad.WebCADGlobal;
            if (webcad2Dmanager.closeWebcadAfterEvent) {
              // ページ更新確認ダイアログを一時的に解除
              window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);

              //閉じる
              marietta.webcad.WebCADGlobal.backLiDARPage();
            }
          } else {
            // エラーメッセージの初期化
            document.getElementById('dialogSaveDialogError').innerText = (info.error.message);

            // HideBusy
            marietta.webcad.WebCADGlobal.hideBusy();
          }
        }).catch(() => {
          // エラーメッセージの初期化
          switch (marietta.webcad.WebCADGlobal.language) {
            case 'en': document.getElementById('dialogSaveDialogError').innerText = ('Error: Cannot find connection. Please check your network.'); break;
            default: document.getElementById('dialogSaveDialogError').innerText = ('通信エラー:ネットワーク環境をご確認ください。'); break;
          }
          marietta.webcad.WebCADGlobal.hideBusy();
        });
      }
    }
}
export default SavePlanDialog;
